/**
 * Resposta de POST /v1/product/validate-support-email quando o domínio
 * não tem MX / não é aceito.
 */
export function isInvalidSupportEmailDomainError(
  errorCode: string | undefined | null,
): boolean {
  return errorCode === 'invalid_domain';
}

/** @deprecated Use isInvalidSupportEmailDomainError com error_code da API */
export function isInvalidSupportEmailDomainMessage(
  message: string | undefined | null,
): boolean {
  if (!message?.trim()) return false;
  const m = message.toLowerCase().normalize('NFC');

  const pt =
    (m.includes('domínio') || m.includes('dominio')) &&
    (m.includes('e-mail de suporte') || m.includes('email de suporte')) &&
    (m.includes('servidor de e-mail') ||
      m.includes('servidor de email') ||
      m.includes('não possui servidor'));

  const en =
    m.includes('support email') &&
    m.includes('domain') &&
    (m.includes('mail server') ||
      m.includes('not valid') ||
      m.includes('does not have'));

  return pt || en;
}
